import React from "react";

const EmptyCart = () => {
  return (
    <div className="font-light text-gray-500 text-center">
      Cart is Empty , Go to Home and Purchase Some
    </div>
  );
};

export default EmptyCart;
